import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Gauge, Key, LockOpen, Phone } from 'lucide-react';

const iconMap = {
  Gauge,
  Key,
  LockOpen,
  Phone
};

export const ServiceCard = ({ service, featured = false }) => {
  const Icon = iconMap[service.icon];

  return (
    <div className={`group relative overflow-hidden rounded-2xl transition-all duration-300 flex flex-col ${
      featured 
        ? 'bg-gradient-to-br from-slate-900 to-slate-800 hover:shadow-2xl hover:shadow-blue-500/20' 
        : 'bg-slate-900 hover:shadow-xl hover:shadow-blue-500/10'
    } ${featured ? 'lg:scale-105' : 'hover:scale-105'}`}>
      {/* Image */}
      <div className="relative h-56 overflow-hidden">
        <img 
          src={service.image} 
          alt={service.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent"></div>
        
        {/* Icon Badge */}
        <div className="absolute top-4 right-4 p-3 bg-blue-600 rounded-xl shadow-lg">
          <Icon className="w-6 h-6 text-white" />
        </div>
      </div>

      {/* Content */}
      <div className="p-6 flex flex-col h-full">
        <h3 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">
          {service.title}
        </h3>
        <p className="text-gray-400 text-sm mb-4">
          {service.shortDesc}
        </p>

        {/* Price - Fixed height to maintain alignment */}
        <div className="mb-4 h-10 flex items-center">
          {service.price && (
            <span className="text-2xl font-bold text-blue-400">{service.price}</span>
          )}
        </div>

        {/* Features - Show first 3 */}
        <ul className="space-y-2 mb-6 flex-grow">
          {service.features.slice(0, 3).map((feature, idx) => (
            <li key={idx} className="flex items-center space-x-2 text-sm text-gray-300">
              <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
              <span>{feature}</span>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <Link
          to={`/${service.id}`}
          className="flex items-center justify-center space-x-2 w-full px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-all group-hover:shadow-lg group-hover:shadow-blue-500/50"
        >
          <span>Learn More</span>
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </div>
  );
};
